<template>
  <div>
    <div class="news_list">
      <NewsItem
        v-for="(item,index) in news"
        :key="item.newsId"
        :news="item"
        :currentIndex="index"
        :showType="showType"
 />
    </div>
    <Pagination
      :total="total"
      :current-page="pageNum"
      :use-a-link="true"
      :first-link="`/information-${newsType}-${industryId}-1/`"
      :link="`/information-${newsType}-${industryId}-`"
      :confirm-btn="true"
      :page-size="pageSize"
      @changePager="changePager" />
  </div>
</template>

<script lang="ts" setup>
  const NewsItem = defineAsyncComponent(() => import('./NewsItem.vue'))
  const Pagination = defineAsyncComponent(() => import('~/components/Pagination/index.vue'))

  const props = defineProps({
    total: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    },
    news: {
      default: (): Record<string, any>[] => []
    },
    newsType: {
      type: Number,
      default: 0
    },
    industryId: {
      type: Number,
      default: 0
    },
    showType:{
      type: Boolean,
      default: false
    }
  })

  const router = useRouter()

  const changePager = (page: number) => {
    router.push({
      path: `/information-${props.newsType}-${props.industryId}-${page}/`
    })
  }
</script>
